export default __webpack_public_path__ + "locales/sr-Cyrl-RS/Payments.json?hash=640f6f4e31e5727301b77abbe4389ccc";